module.exports = __webpack_public_path__ + "static/img/label03.8a381f31.png";